import { cv } from '../Data.jsx'
import { ReactComponent as CurveArrow } from '../assets/curve_down.svg';
import { IoPaperPlane } from "react-icons/io5";

const About = () => {
    return (
        <section className="section-bg-b3 section" id="about">
            <div className="container flex flex-col lg:flex-row gap-20 lg:gap-32 px-2 lg:px-16">
                {/* Left Column: Title, Description, Button */}
                <div className="w-full lg:w-[30%] shrink-0 text-center lg:text-left">
                    <h2 className="text-[clamp(1.75rem,_1.5rem_+_1.5vw,_2.5rem)] font-bold text-title mb-[25px] relative inline-block">
                        Career Overview
                    </h2>

                    <p className="text-normal font-body leading-relaxed mb-8 text-text mx-auto px-2 lg:mx-0 lg:px-0 opacity-80">
                        I’ve had the opportunity to grow and build impactful products while working at a fast-paced startup. I’m always eager to take on new, exciting, and technically challenging opportunities.
                    </p>

                    <a href="https://drive.google.com/file/d/1ax_zYBK2_YIr0ROAi-jPZHi0qQCOez4f/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="btn inline-flex items-center gap-2 text-cs">
                        Resume <IoPaperPlane className="text-lg" />
                    </a>

                    {/* Decorative Arrow */}
                    <div className="hidden lg:block lg:mt-16 ml-0 opacity-60 text-primary">
                        <CurveArrow className="w-[380px] h-[380px] fill-current" />
                    </div>
                </div>

                {/* Right Column: Timeline */}
                <div className="w-full lg:w-[70%] space-y-0">
                    {cv.map((val, id) => {
                        return (
                            <div key={id} className="flex gap-x-4 md:gap-x-12 group">

                                {/* Timeline Line & Dot (Center) */}
                                <div className="relative shrink-0 w-6">
                                    {/* Circle */}
                                    <div className="w-6 h-6 rounded-full bg-primary border-[4px] border-bg relative mx-auto"></div>
                                    {/* Line */}
                                    <div className="w-[2px] bg-primary absolute top-4 bottom-10 left-1/2 -translate-x-1/2"></div>
                                </div>

                                {/* Content Side (Right) */}
                                <div className="pb-10 flex-1">
                                    <h3 className="text-xl font-bold text-title mb-2 mt-[-4px]">{val.title}</h3>
                                    <span className="block text-sm font-bold text-title opacity-80 mb-4">{val.date}</span>
                                    <ul className="list-disc pl-7 space-y-2 text-normal text-text font-body opacity-80">
                                        {val.description.map((desc, idx) => (
                                            <li key={idx} className="leading-relaxed">
                                                {desc}
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}

export default About